import React from "react";
import { Navigate } from "react-router-dom";
import { isLoggedIn } from "../utils/authHelper";
import Header from "./Header";

const ProtectedRoute = ({
  children,
  requiredRoles = [],
  showHeader = true,
}) => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  if (!isLoggedIn() || !token || !user) {
    return <Navigate to="/login" />;
  }

  if (requiredRoles.length > 0 && !requiredRoles.includes(user.role)) {
    // Redirect based on user role
    if (user.role === "staff") return <Navigate to="/teacher/home" />;
    if (user.role === "admin" || user.role === "manager")
      return <Navigate to="/admin/home" />;
    return <Navigate to="/" />;
  }

  return (
    <>
      {showHeader && <Header />}
      {children}
    </>
  );
};

export default ProtectedRoute;
